<template>
  <div>
    <van-nav-bar fixed safe-area-inset-top>
      <template #title>
        <span class="navbar_title">咚咚智能</span>
      </template>
    </van-nav-bar>
    <div class="nav-placeholder"></div>
    <div class="error_img">
      <van-image width="100" height="100" :src="errorImg" />
    </div>
    <div class="msg">We're sorry ...</div>
    <div class="text">{{errorText}}</div>
  </div>
</template>

<script>
// import { getQueryString } from "../utils/public";
export default {
  name: "Error",
  data() {
    return {
      errorImg: require("../assets/icon/error_icon.png"),
      errorText: ''
    };
  },
  mounted() {
    this.errorText= this.$route.query.error;
  },
  methods: {},
};
</script>

<style scoped>
.van-nav-bar {
  background: #ba3939;
}
.navbar_title {
  color: #ffffff !important;
}
.nav-placeholder {
  height: 92px;
}
.error_img {
  display: flex;
  /* border: 1px red solid; */
  margin-top: 250px;
  width: 100%;
  justify-content: center;
  box-sizing: border-box;
}
.text {
  display: flex;
  justify-content: center;
  margin-top: 50px;
  font-size: 28px;
}
.msg {
  display: flex;
  justify-content: center;
  margin-top: 80px;
  font-size: 36px;
  font-weight: bold;
}
</style>